const TOKEN_KEY = "auth_token";

export const authToken = {
  get(): string | null {
    const token = localStorage.getItem(TOKEN_KEY);
    // Проверяем на строку "null" и на пустую строку
    return token && token !== "null" && token !== "" ? token : null;
  },

  set(token: string | null | undefined): void {
    // Защита от сохранения null/undefined как строки "null"
    if (!token || token === "null") {
      this.remove();
      return;
    }
    
    // Явно удаляем старый токен перед сохранением нового
    localStorage.removeItem(TOKEN_KEY);
    localStorage.setItem(TOKEN_KEY, token);
  },

  remove(): void {
    localStorage.removeItem(TOKEN_KEY);
  }
};
